import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import {
  ProcessingTransaction,
  ProcessingTransactionRequest,
  ProcessingTransactionResponse,
} from './types'
import { format, subMonths } from 'date-fns'
import dayjs from 'dayjs'

export const kpiListMounted = createEvent<ProcessingTransactionRequest>()

export const getKPI = fx<
  ProcessingTransactionRequest,
  ProcessingTransactionResponse
>({
  method: 'GET',
  url: `/user/fin_kpi/processing_transaction`,
})

export const $kpiList = restore<ProcessingTransaction[]>(
  getKPI.doneData.map((a) => a.body.items),
  [],
)

export const $totalKPI = restore(
  getKPI.doneData.map((a) => a.body.totalKPI),
  null,
)

export const $totalCountOfKPI = restore(
  getKPI.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: kpiListMounted,
  fn: ({ limit, page, userIds, beginPeriodAt, endPeriodAt }) => {
    let query = {
      limit,
      page,
      where: JSON.stringify({
        beginPeriodAt: beginPeriodAt
          ? beginPeriodAt
          : dayjs().startOf('month').format('YYYY-MM-DD'),
        endPeriodAt: endPeriodAt ? endPeriodAt : dayjs().format('YYYY-MM-DD'),
        user_ids: userIds,
      }),
    }

    return {
      query,
    }
  },
  target: getKPI,
})
